<template>
  <header class="fixed-top">
    <nav class="navbar justify-content-between">
      <div class="navbar-header d-none d-md-block">
        <ul class="nav navbar-nav">
          <li class="nav-item">
            <div class="nav-link dashboard">
              <router-link :to="{name: 'dashboard'}" title="Home" class="dashboard">
                <span v-on:click="refreshBadges" class="title-dashboard"><span class="icon-logo-single-color"></span>Tableau de bord</span>
              </router-link>
              <a href="/" title="Ouvrir le site web dans un nouvel onglet" target="_blank">

                <i class="fas fa-external-link-alt" aria-hidden="true"></i>
              </a>
            </div>

          </li>
        </ul>
      </div>
      <div class="navbar-container">
        <button type="button" class="mobile d-md-none" id="button-mobile-nav">
          <i class="fa fa-bars" aria-hidden="true"></i>
        </button>
        <div class="website d-none d-md-block">
          {{$headerTitle}}
        </div>
        <div class="navbar-top collapse navbar-toggleable-sm">
          <ul class="nav navbar-nav float-right">
            <li class="dropdown nav-item profile">
              <a href="#" title="Profile" class="dropdown-toggle nav-link" id="profile" data-toggle="dropdown" aria-expanded="false" aria-haspopup="true" role="button">
                <span class="avatar">
                  <i class="fas fa-user" aria-hidden="true"></i>
                </span>
                <span class="username" v-if="$user && $user.email">
                  {{$user.email}}
                </span>
                <i class="fa fa-angle-down" aria-hidden="true"></i>
              </a>
              <div class="dropdown-menu dropdown-menu-right border-top-0" aria-labelledby="profile">
                <!-- <a href="#" title="Profile" class="dropdown-item">
    <i class="fa fa-user-o" aria-hidden="true"></i>
    Profile
  </a> -->
                <!-- <div class="dropdown-divider"></div> -->
                <router-link :to="{name: 'setting'}" title="setting" class="dropdown-item" v-if="isAuthorizeSeo()">
                  <i class="fas fa-cog" aria-hidden="true"></i>
                  Configuration
                </router-link>
                <a @click="logout" href="#Logout" title="Logout" class="dropdown-item">
                  <i class="fa fa-power-off" aria-hidden="true"></i>
                  Logout
                </a>

              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>
<script>
import apitools from '@mixins/apitools.js'
import compte from '@mixins/compte.js'

export default {
  name: 'Header',
  mixins: [apitools, compte],
  data() {
    return {}
  },
  computed: {
    headerTitle() {
      return Object.keys(this.$headerTitle).length > 0 ? this.$headerTitle : {}
    }
  },
  methods: {
    logout() {
      axios.post('/api/account/logout').then(response => {
        this.$router.go('/admin')
      })
    },
    refreshBadges() {
      this.getBadges()
    }
  }
}
</script>

<style scoped>
.icon-avatar {
  font-size: 25px;
}

.dashboard .router-link-active span {
  color: #f26522 !important;
}
</style>



// WEBPACK FOOTER //
// shared/layout/Header.vue